
import { publicFeatures } from '../../config/publicFeatures';
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { EnhancedSearch } from './EnhancedSearch';
import { CategoryNavigation } from './CategoryNavigation';
import { LightRays } from '../bg/LightRays';

export function HeroSearchSection({ onSearch, onFilterChange, filters = {} }) {
  // Sync selectedCategory with filters.category
  const selectedCategory = filters.category || 'all';

  const handleSearch = (searchTerm) => {
    onSearch(searchTerm);
  };

  const handleFilterChange = (newFilters) => {
    if (onFilterChange) {
      onFilterChange(newFilters);
    }
  };

  const handleCategorySelect = (categorySlug) => {
    if (onFilterChange) {
      onFilterChange({ ...filters, category: categorySlug });
    }
  };

  return (
    <section className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative min-h-[50vh] sm:min-h-[60vh] flex items-center justify-center overflow-hidden">
        
        <LightRays className="absolute inset-0 w-full h-full pointer-events-none" />

        <div className="relative z-10 container mx-auto text-center space-y-8 sm:space-y-12 pt-12 sm:pt-12">
          {/* Hero Content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-4 sm:space-y-6"
          >
            <img
              src="/images/logo.png"
              alt="TechieDay - Best Tech Deals and Price Tracking Platform Logo"
              className="cta-logo mx-auto w-16 sm:w-[70px] relative z-2"
              loading="eager"
              fetchpriority="high"
              style={{
                transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                transformStyle: 'preserve-3d',
                opacity: 1,
                borderRadius: '14px',
                boxShadow: '0 0 #7b7b7b00, 0 1.1px .2px #7b7b7b0a, 0 2.2px .4px #7b7b7b0c, 0 3.5px .7px #7b7b7b0e, 0 5.1px 1.2px #7b7b7b0f, 0 7px 1.8px #7b7b7b10, 0 9.7px 2.8px #7b7b7b10, 0 13.5px 4.3px #7b7b7b10, 0 19.1px 6.8px #7b7b7b11, 0 28.1px 11px #7b7b7b11, 0 43.8px 18.5px #7b7b7b12, 0 76.7px 34.7px #7b7b7b14',
              }}
            />
            <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-slate-800 via-blue-600 to-purple-600 dark:from-white dark:via-blue-400 dark:to-purple-400 bg-clip-text text-transparent leading-tight px-4">
              Find Your Perfect
              <br />
              <span className="text-blue-600 dark:text-blue-400">Tech Deal</span>
            </h1>
            
            <p className="text-sm sm:text-base text-slate-500 dark:text-slate-400 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed px-4">
              {publicFeatures.priceHistory || publicFeatures.dailyDeals
                ? "Discover unbeatable prices on gaming gear, electronics, and tech accessories. Real-time price tracking with exclusive deals you won't find elsewhere."
                : 'Browse and filter gaming gear, electronics, and tech accessories, and read our buying guides before you choose.'}
            </p>
          </motion.div>

          {/* Enhanced Search */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="px-4"
          >
            <EnhancedSearch 
              onSearch={handleSearch}
              onFilterChange={handleFilterChange}
              filters={filters}
            />
          </motion.div>

          {/* Category Navigation */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="px-4"
          >
            <CategoryNavigation 
              onCategorySelect={handleCategorySelect}
              currentCategory={selectedCategory}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
